export const PHYSICS = {
  // Tick
  TICK_RATE: 30,
  TICK_INTERVAL: 1000 / 30, // ~33.33ms
  SNAPSHOT_RATE: 20,
  SNAPSHOT_INTERVAL: 1000 / 20, // 50ms

  // Movimiento
  BASE_SPEED: 5.0, // unidades/segundo
  BASE_SPEED_PER_TICK: 5.0 / 30, // unidades/tick

  // Jugador
  PLAYER_RADIUS: 0.5,
  PLAYER_BASE_MASS: 1.0,
  PLAYER_ACCELERATION: 0.15,

  // Colisiones automáticas
  COLLISION_DISTANCE: 1.0, // playerRadius * 2

  // Orbes
  ORB_RADIUS: 0.3,
  ORB_COLLECT_RADIUS: 2.0,
  ORB_BOUNCE_HEIGHT: 0.5, // oscilación visual

  // Arena
  ARENA_INITIAL_RADIUS: 40.0,
  ARENA_MIN_RADIUS: 0.0,
  ARENA_CENTER_X: 0,
  ARENA_CENTER_Y: 0,
  ARENA_SHRINK_RATE: 40 / 9000, // 40 unidades en 5 min (9000 ticks) = ~0.00444/tick
  COLLAPSE_MIN_INTERVAL_TICKS: 180, // 6s
  COLLAPSE_MAX_INTERVAL_TICKS: 300, // 10s
  COLLAPSE_SEGMENT_ANGLE: Math.PI / 6, // 30 grados
  COLLAPSE_ACCELERATION_THRESHOLD: 0.5, // acelera después de 50% colapso

  // Tiempos de partida
  COUNTDOWN_TICKS: 150, // 5s
  SPECTATE_TICKS: 0, // 0s — results shown immediately
  VICTORY_TICKS: 150, // 5s
} as const;
